import React from 'react'

import PortalModal from "./PortalModal";

export default class ConfirmModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      show: props.show,
      style: props.style
    }
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  render(){

    let buttonStyle = {
      borderColor: window.CURRENT_PAGE_PRIMARY_COLOR,
      backgroundColor: window.CURRENT_PAGE_PRIMARY_COLOR
    }

    if(this.state.style === "danger"){
      buttonStyle = {
        background: "#fa6160",
        borderColor: "#fa6160"
      }
    }

    return (
      <PortalModal
        show={this.state.show}
        showAsSideMenu={"false"}
        onHide={() => this.props.onHide()}
      >
        <div className="modal-share">

          <div className="modal-head">
            <h2 className="mb-0">Are You Sure?</h2>
          </div>

          <div className="row modal-body">
            <div className="col-md-12">

              <h4>
                You cannot undo this action.
              </h4>

            </div>
          </div>

          <div className="text-right modal-footer">
            <a
              className="btn type--uppercase"
              onClick={() => {
                this.props.onHide()
              }}
            >
              <span className="btn__text">
                Cancel
              </span>
            </a>
            <a
              className="btn btn--primary type--uppercase"
              style={buttonStyle}
              onClick={() => {
                this.props.onConfirm()
              }}
            >
              <span className="btn__text">
                Delete
              </span>
            </a>
          </div>

        </div>


      </PortalModal>
    )
  }
}
